import React from 'react';
import { connect } from 'react-redux';
import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { RENT_VS_BUY } from '../../../../lib/analytics-constants';
import {
  RentVsBuyInput,
  inputOnChange,
  BedrockInterface,
} from '../../../../lib/utils';
import useAnalytics from '../../../../lib/analytics/use-analytics';
import { debouncedTrackInputEvent } from '../../../../lib/analytics/trackers';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const HOADuesInput: React.FC<RentVsBuyInput> = ({
  placeholder,
  value,
  errorMessage,
  dispatch,
  analytics,
  label = '',
  tooltip = '',
  className = '',
  fullWidth,
}) => {
  const segmentAbstract = useAnalytics();
  const formattedPlaceholder = num.formatCurrency(placeholder);
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        entityName: 'homeowners_association_(hoa)_fees_monthly',
        field_type: 'user_type_input',
        field_value: e.target.value,
        field: 'Monthly HOA Fees',
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'HOADues',
      calculator: RENT_VS_BUY,
      inputType: 'currency',
    });
  };

  return (
    <InputMoney
      label={label}
      placeholder={formattedPlaceholder}
      value={String(value)}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  placeholder: state?.rentvsbuyCalculator?.inputs?.HOADues,
  value: state?.rentvsbuyCalculator?.manualInputs?.HOADues,
  errorMessage: state?.validations?.HOADues?.[0],
});

export default connect(mapStateToProps)(HOADuesInput);
